import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import commonErrorHandler from '@/utils/errors'
import { formatDate } from '@/utils/dateUtilities'

export const initialState = {

  loading: false,
  saving: false,
  data: {
    dates: [],
    weeks: []
  },
  contentKey: getComponentKey()
}

export const actionTypes = {
  Loading: 'reportGroupCycleParameters/loading',
  Loaded: 'reportGroupCycleParameters/loaded',
  Saving: 'reportGroupCycleParameters/saving',
  Saved: 'reportGroupCycleParameters/saved',
  Error: 'reportGroupCycleParameters/error'
}

const handleError = (details) => commonErrorHandler(actionTypes.Error, details)

export const actionCreators = {

  get: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Loading })
    context.api.reportGroupCycleParameterService.get(input.reportGroupId, input.reportingCycleSubmissionId)
      .then(response => {
        const data = response || { ...initialState.data }
        dispatch({ type: actionTypes.Loaded, data })
      })
      .catch(error => handleError({ dispatch, error, update: { loading: false } }))
  },
  save: (input, onSaved) => (dispatch) => {
    if (input.data.dates.length > 0) {
      let arr = []
      for (let i = 0; i < input.data.dates.length; i++) {
        arr.push(formatDate(input.data.dates[i]))
      }

      input.data.dates = arr
    }

    dispatch({ type: actionTypes.Saving })
    context.api.reportGroupCycleParameterService.save(input)
      .then(response => {
        dispatch({ type: actionTypes.Saved })
        if (typeof onSaved === 'function') { onSaved() }
      })
      .catch(error => handleError({ dispatch, error, update: { saving: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Loading: return { ...state, loading: true }
    case actionTypes.Loaded: return { ...state, loading: false, data: action.data, contentKey: getComponentKey() }
    case actionTypes.Saving: return { ...state, saving: true }
    case actionTypes.Saved: return { ...state, saving: false }
    case actionTypes.Error: return { ...state, ...action.data }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportGroupCycleParameters.js